import { api } from '@/apis';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useUpdateTrips() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ ids, values }) => {
      return api
        .post('trip-updates', {
          json: { identifiers: ids, ...values },
        })
        .json();
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['trips'] }),
  });
}
